function initStudReviewLabels(scope = document) {
  scope.querySelectorAll('.ss-home-reviews').forEach((section) => {
    if (section.dataset.reviewLabelsReady) return;
    section.dataset.reviewLabelsReady = 'true';
    const update = () => {
      section.querySelectorAll('.trgg-write-review-button').forEach((link) => {
        const text = section.dataset.reviewLabel;
        if (text && link.textContent !== text) link.textContent = text;
      });
      section.querySelectorAll('.splide__arrow--prev').forEach((button) => button.setAttribute('aria-label', section.dataset.previousLabel));
      section.querySelectorAll('.splide__arrow--next').forEach((button) => button.setAttribute('aria-label', section.dataset.nextLabel));
    };
    const observer = new MutationObserver(update);
    observer.observe(section, { childList: true, subtree: true });
    update();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initStudReviewLabels());
else initStudReviewLabels();
document.addEventListener('shopify:section:load', (event) => initStudReviewLabels(event.target));
